import React, { useState } from "react";
import { FaHome, FaChevronDown, FaChevronUp } from "react-icons/fa";

const PropertyTypeDropdown2 = ({ formValues, setFormValues, activeDropdown, setActiveDropdown }) => {
  const [openSubOptions, setOpenSubOptions] = useState({
    Residential: false,
    Commercial: false,
    PG: false,
  });

  const [showAreaOptions, setShowAreaOptions] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState("Sqft");
  const [areaRange, setAreaRange] = useState({ min: "", max: "" });

  const [isMinDropdownOpen, setIsMinDropdownOpen] = useState(false);
  const [isMaxDropdownOpen, setIsMaxDropdownOpen] = useState(false);


  const [isAreaDropdownOpen, setIsAreaDropdownOpen] = useState(false);



  const handleSelectMin = (value) => {
    setAreaRange((prev) => ({ ...prev, min: value }));
    setFormValues((prev) => ({
      ...prev,
      areaRange: { ...prev.areaRange, min: value }, // Update formValues with min value
    }));
    setIsMinDropdownOpen(false);
    setIsMaxDropdownOpen(true);
  };

  const handleSelectMax = (value) => {
    setAreaRange((prev) => ({ ...prev, max: value }));
    setFormValues((prev) => ({
      ...prev,
      areaRange: { ...prev.areaRange, max: value }, // Update formValues with max value
    }));

    setIsMaxDropdownOpen(false);
    if (areaRange.min && value) {
      setIsMinDropdownOpen(false);
      setIsMaxDropdownOpen(false);
    }

  };



  const handleSelect = (item, key, toggleFn) => {
    setFormValues((prev) => {
      const alreadySelected = prev[key]?.includes(item);
      const updatedSelection = alreadySelected
        ? prev[key].filter((type) => type !== item)
        : [...(prev[key] || []), item];
      if (toggleFn) toggleFn(!alreadySelected);
      return { ...prev, [key]: updatedSelection };
    });
  };

  const toggleSubOption = (section) => {
    setOpenSubOptions((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const tabOptions = {
    PG: {
      firstSelected: "Occupancy Type",
      sections: [
        {
          title: "Gender",
          options: ["Boys", "Girls"],
          key: "pgGender",
          subOptions: {}
        },
        {
          title: "Looking For",
          options: ["PG", "Room/Bed in a Shared-Flat"],
          key: "lookingFor",
          subOptions: {
            PG: ["Single Room", "Double Sharing Room", "Triple Sharing Room"],
          },
        },
      ],
    },
    Plot: {
      firstSelected: "Property Type",
      sections: [
        {
          title: "Residential",
          options: ["Residential Plot", "Commercial Land", "Agricultural Land"],
          key: "plotType",
          
          subOptions: {}
        },
      ],
    },
    Default: {
      firstSelected: "Property Type",
      sections: [
        {
          title: "Residential",
          options: ["Flat", "House/Villa", "Plot"],
          key: "propertyType",
          subKey: "bhkSelection",  // Add dynamic key for sub-selection
          subOptions: { Flat: ["1 Bhk", "2 Bhk", "3 Bhk", "4 Bhk", "5 Bhk", "5+ Bhk"] },
        },
        {
          title: "Commercial",
          options: ["Office Space", "Shop/Showroom", "Commercial Land", "Warehouse/Godown", "Industrial Building", "Industrial Shed"],
          key: "commercialSelection",
          subOptions: {},
        },
      ],
    },
    Commercial: {
      firstSelected: "Property Type",
      sections: [
        {
          title: "Commercial",
          options: ["Office Space", "Shop/Showroom", "Commercial Land", "Warehouse/Godown", "Industrial Building", "Industrial Shed"],
          key: "commercialSelection",
          subOptions: {},
        },
      ],
    },

  };

  const selectedTab = tabOptions[formValues?.activeTab] || tabOptions.Default;


  // Function to dynamically set the first selected text with counts
  const getFirstSelectedText = (section) => {
    const selectedItems = formValues[section.key] || [];
    const selectedSubItemsCount = selectedItems.reduce((acc, item) => {
      if (section.subOptions[item]) {
        return acc + section.subOptions[item].length;
      }
      return acc;
    }, 0);

    const itemName = selectedItems.length > 0 ? selectedItems[0] : selectedTab.firstSelected;

    return selectedSubItemsCount > 0
      ? `${itemName} +${selectedSubItemsCount}`
      : itemName;
  };



  return (
    <div className="relative w-[160px]">
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={() => setActiveDropdown(activeDropdown === "propertyType" ? null : "propertyType")}
      >
        <div className="flex gap-2 text-sm whitespace-nowrap w-[80%] overflow-hidden">
          <FaHome className="text-gray-500 h-5 w-[15%]" />
          <span className="text-gray-700 max-w-[65%] truncate">{selectedTab.firstSelected}</span>
        </div>
        <FaChevronDown
          className={`text-gray-500 w-[20%] h-4 transition-transform duration-300 ${activeDropdown === "propertyType" ? "-rotate-180" : "rotate-0"
            }`}
        />
      </div>

      {activeDropdown === "propertyType" && (
        <div className="absolute top-full mt-2  w-full md:w-[400px] bg-white p-4 rounded-lg shadow-lg border border-gray-300 z-10 ">
          {selectedTab.sections.map((section, index) => (
            <div key={index} className="mt-4">
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => section.subOptions && toggleSubOption(section.title)}
              >
                <h3 className="text-sm font-semibold text-gray-700">{section.title}</h3>
                {section.subOptions && (
                  <FaChevronUp
                    className={`text-gray-500 w-4 h-4 transition-transform duration-300 ${openSubOptions[section.title] ? "rotate-0" : "-rotate-180"
                      }`}
                  />
                )}
              </div>
              {openSubOptions[section.title] && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {section.options.map((item, idx) => (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => handleSelect(item, section.key)}
                      className={`px-4 py-1 text-sm rounded-full transition-all duration-200 ease-in-out ${formValues[section.key]?.includes(item)
                        ? "bg-[#2b463c] text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                        }`}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              )}
              {section.subOptions && openSubOptions[section.title] && formValues[section.key]?.some((item) => section.subOptions[item]) && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {section.subOptions[formValues[section.key]?.find((item) => section.subOptions[item])]?.map((subItem, subIndex) => (
                    <button
                      key={subIndex}
                      type="button"
                      onClick={() => handleSelect(subItem, "subSelection")}
                      className={`px-4 py-1 text-sm rounded-full transition-all duration-200 ease-in-out ${formValues.subSelection?.includes(subItem) ? "bg-black text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                        }`}
                    >
                      {subItem}
                    </button>
                  ))}
                </div>
              )}

              {openSubOptions[section.title] && formValues?.activeTab === "Plot" && formValues?.plotType && formValues?.plotType.length > 0 && (
                  <div className="mt-2 bg-white  w-[300px] rounded-[12px]  border border-gray-300 flex gap-4 h-[30px] relative">
                    <div className="flex items-center gap-2 w-1/2">
                      <select
                        value={selectedUnit}
                        onChange={(e) => setSelectedUnit(e.target.value)}
                        className=" px-4 rounded-md outline-none"
                      >
                        <option value="Sqft">Sqft</option>
                        <option value="Sq. Meter">Sq. Meter</option>
                        <option value="Acres">Acres</option>
                      </select>
                    </div>
                    <div className="h-full w-[2px] bg-gray-300"></div>
                    <div className="flex py-2 items-center gap-1 cursor-pointer  w-1/2"
                      onClick={() => setIsMinDropdownOpen(!isMinDropdownOpen)}
                    >
                      <span>{
                        areaRange.min && areaRange.max
                          ? `${areaRange.min}-${areaRange.max}`
                          : areaRange.min
                            ? `${areaRange.min}-Max`
                            : areaRange.max
                              ? `Min-${areaRange.max}`
                              : "Area"
                      }</span>
                      <FaChevronDown className={`text-gray-500 w-4 h-4 transition-transform duration-300 ${isMinDropdownOpen || isMaxDropdownOpen ? "rotate-180" : "rotate-0"}`} />


                      {(isMinDropdownOpen || isMaxDropdownOpen) && (
                        <div className="absolute flex border p-2 top-full right-0 bg-white w-[200px]">
                          <div className="flex flex-col w-1/2 border-r pr-2">
                            <span className="font-bold text-red-500 mb-2">MIN</span>
                            <div className="flex flex-wrap gap-2 max-h-[200px] overflow-y-auto">
                              {[100, 200, 300, 400, 500, 1000, 1500, 2000].map((value) => (
                                <button key={value} className="py-1 px-2 text-left hover:bg-gray-200 w-full" onClick={() => handleSelectMin(value)}>
                                  {value}
                                </button>
                              ))}
                            </div>
                          </div>
                          <div className="flex flex-col w-1/2 pl-2">
                            <span className="font-bold text-gray-500 mb-2">MAX</span>
                            <div className="flex flex-wrap gap-2 max-h-[200px] overflow-y-auto">
                              {[200, 300, 400, 500, 1000, 1500, 2000, 5000].map((value) => (
                                <button key={value} className="py-1 px-2 text-left hover:bg-gray-200 w-full" onClick={() => handleSelectMax(value)}>
                                  {value}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                )
              }

            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PropertyTypeDropdown2;
